/** 
 * Type definition for a Lime user address
 */
export interface Address {
    address_1?: string;
    address_2?: string;
    city?: string;
    state?: string;
    zip?: string;
}

export const addressToString = (address: Address) => {
    return `${address.address_1} ${address.address_2} ${address.city} ${address.state} ${address.zip}`;
}

// In SAAS application, default state should be localized
export const defaultAddress: Address = {
    address_1: "",
    address_2: "",
    city: "",
    state: "OH",
    zip: ""
}
